import { useDispatch, useSelector } from 'react-redux';
import { selectIsContactFormOpen, setContactFormDialogOpen } from '../../redux/slicers/subscriptionSlicer';
import { HubspotFormModal } from '../../common/HubspotFormModal';

export const ContactUs = () => {
  const dispatch = useDispatch();
  const open = useSelector(selectIsContactFormOpen);

  return (
    <HubspotFormModal
      title="Contact Us"
      portalId="6917454"
      formId="af28dea8-6738-4487-b21d-44314aa60bbb"
      open={open}
      onClose={() => dispatch(setContactFormDialogOpen(false))}
    />
  );
};